import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AdminUsersService } from '../services/admin-users.service';
import { RouteHelperService } from '../../core/services/route-helper.service';
import { LocationService } from '../../locations/services/location.service';
import { EditAdminUserComponent } from './edit-admin-user.component';
import { AuthService } from '../../auth/services/auth.service';
import { AuthDataStorageService } from '../../auth/services/auth-data-storage.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'ch-edit-admin-user',
  templateUrl: './edit-admin-user.component.html',
  styleUrls: ['./edit-admin-user.component.css'],
})
export class ProfileEditComponent extends EditAdminUserComponent {
  constructor(
    adminUsersService: AdminUsersService,
    activatedRoute: ActivatedRoute,
    router: Router,
    routeHelperService: RouteHelperService,
    locationService: LocationService,
    authDataStorageService: AuthDataStorageService,
    titleService: Title
  ) {
    super(adminUsersService, activatedRoute, router, routeHelperService, locationService, authDataStorageService, titleService);

    this.initialPageBreadcrumbName = 'Edit Profile';
  }

  protected getCurrentUserId() {
    return this.authDataStorageService.getLoggedUserId();
  }

  protected isEditPage() {
    return true;
  }

  public cancel() {
    this.router.navigateByUrl('/');
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/admin-users/edit-admin-user/profile-edit.component.ts